// Copyright (c) Proto Labs, Inc. All Rights Reserved.
export class ProfileProxy {
    constructor(profile) {
        this.iss = '';
        this.sub = '';
        this.aud = '';
        this.exp = 0;
        this.iat = 0;
        Object.keys(profile).forEach((key) => {
            this[key] = profile[key];
        });
    }
}
//# sourceMappingURL=ProfileProxy.js.map